<template>
  <form class="tile filters filter-form">
    <div class="flex__between heading--box">
      <span class="heading">Filters</span>
      <button class="btn btn__small" @click.prevent="resetFilters">Reset Filters</button>
    </div>
    <label class="filter-form--label" for="name">
      LO Name:
      <input
        type="text"
        v-model="form.name"
        id="name"
        @keypress.prevent.enter="submitFilters"
      />
    </label>
    <label class="filter-form--label" for="nmls">
      NMLS Number:
      <input
        type="text"
        v-model="form.nmls"
        id="nmls"
        @keypress.prevent.enter="submitFilters"
      />
    </label>
    <label class="filter-form--label" for="state">
      State License:
      <select id="state" name="state" v-model="form.state">
        <option value="any">Any</option>
        <option value="AL">Alabama</option>
        <option value="AK">Alaska</option>
        <option value="AZ">Arizona</option>
        <option value="AR">Arkansas</option>
        <option value="CA">California</option>
        <option value="CO">Colorado</option>
        <option value="CT">Connecticut</option>
        <option value="DE">Delaware</option>
        <option value="DC">District Of Columbia</option>
        <option value="FL">Florida</option>
        <option value="GA">Georgia</option>
        <option value="HI">Hawaii</option>
        <option value="ID">Idaho</option>
        <option value="IL">Illinois</option>
        <option value="IN">Indiana</option>
        <option value="IA">Iowa</option>
        <option value="KS">Kansas</option>
        <option value="KY">Kentucky</option>
        <option value="LA">Louisiana</option>
        <option value="ME">Maine</option>
        <option value="MD">Maryland</option>
        <option value="MA">Massachusetts</option>
        <option value="MI">Michigan</option>
        <option value="MN">Minnesota</option>
        <option value="MS">Mississippi</option>
        <option value="MO">Missouri</option>
        <option value="MT">Montana</option>
        <option value="NE">Nebraska</option>
        <option value="NV">Nevada</option>
        <option value="NH">New Hampshire</option>
        <option value="NJ">New Jersey</option>
        <option value="NM">New Mexico</option>
        <option value="NY">New York</option>
        <option value="NC">North Carolina</option>
        <option value="ND">North Dakota</option>
        <option value="OH">Ohio</option>
        <option value="OK">Oklahoma</option>
        <option value="OR">Oregon</option>
        <option value="PA">Pennsylvania</option>
        <option value="RI">Rhode Island</option>
        <option value="SC">South Carolina</option>
        <option value="SD">South Dakota</option>
        <option value="TN">Tennessee</option>
        <option value="TX">Texas</option>
        <option value="UT">Utah</option>
        <option value="VT">Vermont</option>
        <option value="VA">Virginia</option>
        <option value="WA">Washington</option>
        <option value="WV">West Virginia</option>
        <option value="WI">Wisconsin</option>
        <option value="WY">Wyoming</option>
      </select>
    </label>
    <label class="filter-form--label" for="address">
      Address:
      <input
        id="address"
        name="address"
        v-model="form.address"
        @keypress.prevent.enter="submitFilters"
      />
    </label>
    <label class="filter-form--label" for="sort">
      Sort Order:
      <select id="sort" name="sort" v-model="form.sort">
        <option value="a-z">A to Z</option>
        <option value="z-a">Z to A</option>
      </select>
    </label>
    <button class="btn btn--submit" @click.prevent="submitFilters">Apply Filters</button>
  </form>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: ["filters"],
  data() {
    return {
      form: {
        name: this.filters.name,
        nmls: this.filters.nmls,
        state: this.filters.state,
        address: this.filters.address,
        sort: this.filters.sort
      }
    };
  },
  methods: {
    ...mapActions({
      startSetFilters: "loanOfficers/startSetFilters"
    }),
    resetFilters() {
      this.form.name = "";
      this.form.nmls = "";
      this.form.state = "any";
      this.form.address = "";
      this.form.sort = "a-z";
      this.startSetFilters(this.form);
    },
    submitFilters() {
      this.startSetFilters(this.form);
    }
  }
};
</script>

<style scoped lang="scss">
</style>